import { useEffect } from 'react';


const OnlineCourse = ({ onlineCourseSection }) => {


  if (!onlineCourseSection) return null;

  return (
    <section className="mb-3 bg-french">
      <div className="container">
        <h2 className="sec-title text-center" >
          {onlineCourseSection.heading}
        </h2>

        <div className="row  d-flex justify-content-center align-items-center">
          <div className="col-md-6">
            <h2 className="mb-3 mt-3 text-center" >
              {onlineCourseSection.objective_title}
            </h2>
            <p>{onlineCourseSection.objective_text}</p>
            <ul className="list-unstyled p-0 p-md-3">
              {onlineCourseSection.objectives?.map((obj, i) => (
                <li key={i} className="mb-3" >
                  <i className={`fa ${obj.icon_class} me-2`}></i>
                  {obj.text}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-md-6  d-flex justify-content-center align-items-center">
            <div className="modern-card d-flex align-items-center p-4" >
              <div>
                <div className="d-flex align-items-center gap-2 mb-2 justify-content-center">
                  <div className="icon-circle me-2">
                    <i className={`fa ${onlineCourseSection.highlight_icon}`}></i>
                  </div>
                  <h4 className='modern-card-title mb-0'>{onlineCourseSection.highlight_title}</h4>
                </div>
                <p className='modern-card-text mb-0'>{onlineCourseSection.highlight_content}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OnlineCourse;
